/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryNoteMetaDataResponse } from '../../models/delivery-note-meta-data-response';
import { KeyType } from '../../models/key-type';
import { NameType } from '../../models/name-type';

export interface GetDeliveryNoteMetaData$Params {
  organizationKey: KeyType;
  deliveryNoteKey: KeyType;
  metaDataKey: NameType;
}

export function getDeliveryNoteMetaData(http: HttpClient, rootUrl: string, params: GetDeliveryNoteMetaData$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryNoteMetaDataResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryNoteMetaData.PATH, 'get');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('metaDataKey', params.metaDataKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryNoteMetaDataResponse>;
    })
  );
}

getDeliveryNoteMetaData.PATH = '/organizations/{organizationKey}/delivery-notes/{deliveryNoteKey}/metadata/{metaDataKey}';
